import StoreLogo from './StoreLogo.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'storeLogo', StoreLogo);
  },
};
